"use strict";

exports.__esModule = true;
exports.getConfig = getConfig;
exports.__setConfig = __setConfig;
exports.setSsrConfig = setSsrConfig;
var config = {};

try {
  //@ts-ignore
  config = global.CONFIG = ___APP__CONFIG___; // eslint-disable-line no-undef
} catch (e) {
  //@ts-ignore
  // istanbul ignore next
  config = process.env.CHEGG_CONFIG ? JSON.parse(process.env.CHEGG_CONFIG) : {};
} // eslint-disable-next-line @typescript-eslint/no-explicit-any


function getConfig(key) {
  return config[key];
}

function __setConfig(key, value) {
  if (!process.env.TEST) {
    throw new Error('__setConfig should only be used in tests');
  }

  config[key] = value;
}

function setSsrConfig(_config) {
  if (_config === void 0) {
    _config = '{}';
  }

  try {
    config = JSON.parse(_config);
  } catch (e) {
    config = _config;
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-web-tools/config-plugin/dist/utils.js
// module id = 4107
// module chunks = 11